import { useCallback, useMemo } from "react";
import { useNotification } from "@/app/context/NotificationContext";
import { useUserSettingsStore } from "@/features/preferences/user-settings.store";
import { saveUserSettingsChange } from "@/features/preferences/save-user-settings-change";
import {
  BOARD_PREFERENCE_KEYS,
  boardPreferencesPatch,
  resolveBoardPreferences,
  type BoardPreferenceContext,
  type ReviewBoardSettingsPatch,
} from "./review-board-settings";

export const useBoardPreferences = (context: BoardPreferenceContext) => {
  const userSettings = useUserSettingsStore((state) => state.settings);
  const update = useUserSettingsStore((state) => state.update);
  const { showNotification } = useNotification();
  const settings = useMemo(() => resolveBoardPreferences(userSettings, context), [userSettings, context]);
  const change = useCallback(
    (patch: ReviewBoardSettingsPatch) => {
      void saveUserSettingsChange(
        update,
        boardPreferencesPatch(useUserSettingsStore.getState().settings, context, patch),
        showNotification,
      );
    },
    [context, update, showNotification],
  );
  const reset = useCallback(() => {
    void saveUserSettingsChange(update, { [BOARD_PREFERENCE_KEYS[context]]: null }, showNotification);
  }, [context, update, showNotification]);
  return { settings, change, reset, customized: userSettings[BOARD_PREFERENCE_KEYS[context]] != null };
};
